import React, { useEffect } from 'react';

import { UseFormReturn } from 'react-hook-form';

import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import { BorrowerRole } from 'enums/BorrowerRole';
import {
  getEmploymentVariableName,
  getIsInitialValueNotNull,
} from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/additionalInformation.utils';
import {
  CurrentEmploymentVariable,
  EmploymentStatusInformationInputLabel,
} from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/additionalInformation.enums';
import Select from 'components/Select';
import {
  BRANCH_OF_SERVICE_OPTIONS,
  MILITARY_PAYGRADE_OPTIONS,
} from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/additionalInformation.constants';
import { getErrorMessageForRequiredFields } from 'prequalificationV2/utils/stringUtils';
import styles from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/InformationTabs.module.scss';

const ActiveMilitaryInformation = ({
  formMethods,
  borrowerType,
  watcher,
}: {
  formMethods: UseFormReturn<any, any>;
  borrowerType: BorrowerRole;
  watcher: any;
}) => {
  const { variables } = useAppSelector((state) => state.application);
  const applicationVariables = variables!;

  const {
    register,
    clearErrors,
    formState: { errors },
    setValue,
  } = formMethods;

  useEffect(() => {
    register(getEmploymentVariableName(CurrentEmploymentVariable.MilitaryPaygrade, borrowerType), {
      required: {
        value: !watcher[getEmploymentVariableName(CurrentEmploymentVariable.MilitaryPaygrade, borrowerType)],
        message: getErrorMessageForRequiredFields(EmploymentStatusInformationInputLabel.MilitaryPaygrade),
      },
    });
    register(getEmploymentVariableName(CurrentEmploymentVariable.BranchOfService, borrowerType), {
      required: {
        value: !watcher[getEmploymentVariableName(CurrentEmploymentVariable.BranchOfService, borrowerType)],
        message: getErrorMessageForRequiredFields(EmploymentStatusInformationInputLabel.BranchOfService),
      },
    });
  }, []);

  return (
    <div className={styles.formRow}>
      <Select
        name={getEmploymentVariableName(CurrentEmploymentVariable.BranchOfService, borrowerType)}
        label={EmploymentStatusInformationInputLabel.BranchOfService}
        value={BRANCH_OF_SERVICE_OPTIONS.find(
          (option) =>
            option.value ===
            watcher[getEmploymentVariableName(CurrentEmploymentVariable.BranchOfService, borrowerType)],
        )}
        inputContainerClassName={styles.input}
        onChange={(value) => {
          clearErrors(getEmploymentVariableName(CurrentEmploymentVariable.BranchOfService, borrowerType));
          setValue(getEmploymentVariableName(CurrentEmploymentVariable.BranchOfService, borrowerType), value);
        }}
        options={BRANCH_OF_SERVICE_OPTIONS}
        isSearchable
        errorMessage={
          errors[getEmploymentVariableName(CurrentEmploymentVariable.BranchOfService, borrowerType)]?.message
        }
        isClearable
        isDisabled={getIsInitialValueNotNull(
          applicationVariables[getEmploymentVariableName(CurrentEmploymentVariable.BranchOfService, borrowerType)],
        )}
      />
      <Select
        name={getEmploymentVariableName(CurrentEmploymentVariable.MilitaryPaygrade, borrowerType)}
        label={EmploymentStatusInformationInputLabel.MilitaryPaygrade}
        value={MILITARY_PAYGRADE_OPTIONS.find(
          (option) =>
            option.value ===
            watcher[getEmploymentVariableName(CurrentEmploymentVariable.MilitaryPaygrade, borrowerType)],
        )}
        inputContainerClassName={styles.input}
        onChange={(value) => {
          clearErrors(getEmploymentVariableName(CurrentEmploymentVariable.MilitaryPaygrade, borrowerType));
          setValue(getEmploymentVariableName(CurrentEmploymentVariable.MilitaryPaygrade, borrowerType), value);
        }}
        options={MILITARY_PAYGRADE_OPTIONS}
        isSearchable
        errorMessage={
          errors[getEmploymentVariableName(CurrentEmploymentVariable.MilitaryPaygrade, borrowerType)]?.message
        }
        isClearable
        isDisabled={getIsInitialValueNotNull(
          applicationVariables[getEmploymentVariableName(CurrentEmploymentVariable.MilitaryPaygrade, borrowerType)],
        )}
      />
    </div>
  );
};

export default ActiveMilitaryInformation;
